import { ReactComponent as Replay } from 'assets/icons/icon-replay.svg';

export default Replay;
